// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-file-input--hide.v-input .v-field,
:where(.vuetify-styles) .v-file-input--hide.v-input .v-input__control,
:where(.vuetify-styles) .v-file-input--hide.v-input .v-input__details {
  display: none;
}
:where(.vuetify-styles) .v-file-input--hide.v-input .v-input__prepend {
  grid-area: control;
  margin: 0 auto;
}
:where(.vuetify-styles) .v-file-input--chips.v-input--density-compact .v-field--variant-solo .v-label.v-field-label--floating,
:where(.vuetify-styles) .v-file-input--chips.v-input--density-compact .v-field--variant-solo-inverted .v-label.v-field-label--floating,
:where(.vuetify-styles) .v-file-input--chips.v-input--density-compact .v-field--variant-filled .v-label.v-field-label--floating,
:where(.vuetify-styles) .v-file-input--chips.v-input--density-compact .v-field--variant-solo-filled .v-label.v-field-label--floating {
  top: 0px;
}
:where(.vuetify-styles) .v-file-input .v-field__input {
  word-break: break-word;
}
:where(.vuetify-styles) .v-file-input input[type=file] {
  height: 100%;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 0;
}
:where(.vuetify-styles) .v-file-input--dragging input[type=file] {
  z-index: 1;
}
:where(.vuetify-styles) .v-file-input .v-input__details {
  padding-inline: 16px;
}
:where(.vuetify-styles) .v-input--plain-underlined.v-file-input .v-input__details {
  padding-inline: 0;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VFileInput/VFileInput.css"],"names":[],"mappings":"AAAA;;;EAGE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;;;;EAIE,QAAQ;AACV;AACA;EACE,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,OAAO;EACP,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB","sourcesContent":[".v-file-input--hide.v-input .v-field,\n.v-file-input--hide.v-input .v-input__control,\n.v-file-input--hide.v-input .v-input__details {\n  display: none;\n}\n.v-file-input--hide.v-input .v-input__prepend {\n  grid-area: control;\n  margin: 0 auto;\n}\n.v-file-input--chips.v-input--density-compact .v-field--variant-solo .v-label.v-field-label--floating,\n.v-file-input--chips.v-input--density-compact .v-field--variant-solo-inverted .v-label.v-field-label--floating,\n.v-file-input--chips.v-input--density-compact .v-field--variant-filled .v-label.v-field-label--floating,\n.v-file-input--chips.v-input--density-compact .v-field--variant-solo-filled .v-label.v-field-label--floating {\n  top: 0px;\n}\n.v-file-input .v-field__input {\n  word-break: break-word;\n}\n.v-file-input input[type=file] {\n  height: 100%;\n  left: 0;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: 0;\n}\n.v-file-input--dragging input[type=file] {\n  z-index: 1;\n}\n.v-file-input .v-input__details {\n  padding-inline: 16px;\n}\n.v-input--plain-underlined.v-file-input .v-input__details {\n  padding-inline: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
